import { select } from "@angular-redux/store";
import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../../../environments/environment";
import { ApplicationUser } from "../../../../models/application.user.interface";


@Component({
    moduleId: module.id,
    selector: 'pb-next-transport-info',
    templateUrl: './next-transport-info.component.html',
})

export class NextTransportInfoComponent implements OnInit {
    @select('applicationUser') public applicationUser$: Observable<ApplicationUser>;

    @Input() planningBlock: any;

    public enableAutocomplete: boolean = false;
    public showRailInfo : boolean = false ; 
    public showShippingInfo : boolean = false ;
    constructor() {
    }

    ngOnInit(): void {
        this.showRailInfo = environment.railway; 
        this.showShippingInfo = environment.shipping;
        
        this.applicationUser$.subscribe((applicationUser: ApplicationUser) => {
            if (applicationUser) {
              this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
            }
          });
    }

}
